import { BrowserModule } from "@angular/platform-browser";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { environment } from "src/environments/environment";
import { CoreModule } from "./core/core.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { RootStoreModule } from "./store";
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MsalModule, MsalService, MsalGuard, MsalInterceptor, MsalBroadcastService, MsalRedirectComponent, MsalGuardConfiguration, MsalInterceptorConfiguration } from "@azure/msal-angular";
import { PublicClientApplication, InteractionType, BrowserCacheLocation, IPublicClientApplication, LogLevel } from "@azure/msal-browser";

export function msalInitFactory(msal: MsalService) {
  return async () => {
    const result = await msal.instance.handleRedirectPromise();
    if (result?.account) {
      msal.instance.setActiveAccount(result.account);
    } else if (!msal.instance.getActiveAccount()) {
      const accts = msal.instance.getAllAccounts();
      if (accts.length) msal.instance.setActiveAccount(accts[0]);
    }
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    CoreModule,
    NgbModule,
    RootStoreModule,
    StoreDevtoolsModule.instrument({
      name: "MoE - Member's Web",
      maxAge: 25,
      logOnly: environment.production,
    }),    
    HttpClientModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.msal.clientId,
          authority: environment.msal.authority,
          redirectUri: environment.msal.redirectUri,
          postLogoutRedirectUri: environment.msal.postLogoutRedirectUri,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage, // This configures where your cache will be stored
          storeAuthStateInCookie: false, // Set to true for Internet Explorer 11
        },
        system: {
          loggerOptions: {          
            loggerCallback: (level, message, containsPii) => {
              console.log(message);
            },
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false,
          },
        },
      }),
      {
        interactionType: InteractionType.Redirect, // MSAL Guard Configuration
        authRequest: {
          scopes: environment.msal.scopes,
        },
      },
      {
        interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
        protectedResourceMap: new Map([
          [environment.msal.protectedResources.apiUrl, environment.msal.protectedResources.scopes],
        ])
      }
    )    
  ],
    providers: [
        { provide: APP_INITIALIZER, useFactory: msalInitFactory, deps: [MsalService], multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService
    ],
    bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule {}
